module.exports = __webpack_public_path__ + "static/media/share_light.439c34ee.svg";